export default [
    {
        "id": "product-details-1",
        "plugin": null,
        "pluginId": null,
        "name": null
    }
]